import { useQuery } from "@tanstack/react-query";

import { orpc } from "@/client";
import { usePageVisible } from "@/hooks/use-page-visible";
import { PollCadence } from "@/lib/poll-cadence";
import { cn } from "@/lib/utils";

export function AgoraNavBadge() {
	const visible = usePageVisible();

	const { data } = useQuery(
		orpc.today.queue.queryOptions({
			refetchInterval: () => PollCadence.pipeline({ visible }),
		}),
	);

	if (!data) {
		return null;
	}

	const count = data.actions.length;

	return (
		<span
			data-slot="agora-nav-badge"
			className={cn(
				"ml-auto rounded-full px-1.5 py-0.5 text-xs font-medium",
				count > 0
					? "bg-destructive text-destructive-foreground"
					: "bg-sidebar-accent/15 text-inherit",
			)}
		>
			{count}
		</span>
	);
}
